// @flow
import React, { Component } from 'react';
import ReactYoutube from 'react-youtube';
import Dialog from 'material-ui/Dialog';
import { Fonts, Colors } from '../../../themes';

type Props = {
  onClose: Function,
  open?: boolean,
  videoId?: string,
  videoWidth: number,
  videoHeight: number,
  title?: string,
};

export default class VideoModal extends Component<Props> {
  static defaultProps: {
    videoWidth: 640,
    videoHeight: 360,
  };

  onClose = () => {
    this.props.onClose();
  };

  render() {
    const width = this.props.videoWidth || 640;
    const height = this.props.videoHeight || 360;

    return (
      <Dialog
        title={this.props.title}
        open={this.props.open}
        onRequestClose={this.onClose}
        modal={false}
        bodyStyle={{ padding: 0 }}
        titleStyle={{ ...Fonts.style.secondary, color: Colors.tertiaryText, backgroundColor: Colors.primary }}
        contentStyle={{ width }}
      >
        <div style={{ width, height }}>
          <ReactYoutube videoId={this.props.videoId} opts={{
            height: height,
            width: width,
            playerVars: {
              rel: 0,
            },
          }}
          />
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/tutorials/components/VideoModal.js